import React, { FC, ReactNode } from 'react';
import styles from './error-alert.module.scss';

interface ErrorAlertProps {
  title: string;
  children?: ReactNode;
}

const ErrorAlert: FC<ErrorAlertProps> = ({ title, children }) => (
  <div role="alert" className={styles.alert}>
    <p className={styles.title}>{title}</p>
    {children}
  </div>
);

export default ErrorAlert;
